import { createSlice } from '@reduxjs/toolkit'

import { runsAdapter } from './runsAdapter'
import { toggleRunStatus } from './thunks/toggleRunStatus'

export const initialRunState = runsAdapter.getInitialState()

export const runsSlice = createSlice({
  name: 'runs',
  initialState: initialRunState,
  reducers: {
    upsertMultipleRuns: (state, action) => {
      runsAdapter.upsertMany(state, action.payload)
    },
  },
  extraReducers: builder => {
    builder
      .addCase(toggleRunStatus.fulfilled, (state, action) => {
        const id = action.payload

        if (!id) return

        const depot = state.entities[id]

        if (depot) {
          depot.isActive = !depot.isActive
        }
      })
  },
})

export const { upsertMultipleRuns } = runsSlice.actions